import React from 'react';
import EditQuizComponent from '../../components/admin/EditQuizComponent';

const EditQuiz = () => {
  return (
    <div>
      <EditQuizComponent />
    </div>
  );
};

export default EditQuiz;